import { Typography } from '@mui/material'
import { styled } from '@mui/system'
import * as React from 'react'

const Rootdiv = styled('div')({
  height: "606px",
  width: "160px",
  minWidth: "160px",
  borderTop: "5px solid #56584e",
  borderBottom: "5px solid #56584e",
  margin: "0 12px 0 12px",
})

const DivLetter = styled(Typography)({
  height: "70px",
  borderBottom: "1px solid #56584e",
  color: "#6b6a62",
  fontWeight: "300",
  textAlign: "center",
  margin: "20px 0 0 0",
})

const ItemList  = React.forwardRef((props, ref) => {
  return (
    <Rootdiv ref={ref}>
      <DivLetter variant="h5" sx={{fontSize: (props.content.length > 6) ? "28px" : "36px"}}>
        {props.content}
      </DivLetter>
    </Rootdiv>
  )
})

export default ItemList;